<template>
  <v-dialog :value="value" @input="$emit('input')" transition="fade-transition" max-width="500px">
    <v-card v-if="activeMasterListData" style="min-width:400px">
      <v-card-title class="headline pb-5">{{editTimelineData ? 'Update' : 'Add'}} Amount</v-card-title>
      <v-card-text>
        <!-- <v-row>
          <v-col class="pb-0" cols="12" md="5" sm="12">
            <p class="title-1 form-label">Quote Amount: </p>
          </v-col>
          <v-col class="pb-0" cols="12" md="7" sm="12">
            <b>${{quoteAmt | thousandSeprator}}</b>
          </v-col>
        </v-row> -->
        <v-row>
          <v-col class="pb-0" cols="12" md="5" sm="12">
            <p class="title-1 form-label">Available Amount: </p>
          </v-col>
          <v-col class="pb-0" cols="12" md="7" sm="12">
            <b>${{availableAmt | thousandSeprator}}</b>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row>
          <v-col class="pb-0" cols="12" md="5" sm="12">
            <p class="title-1 form-label">Amount: </p>
          </v-col>
          <v-col class="pb-0" cols="12" md="7" sm="12">
            <v-text-field
              type="number"
              v-model="activeMasterListData.quoteAmt"
              hide-details
              placeholder=""
              prefix="$"
              outlined
              dense
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="mt-2">
          <v-col class="pb-0" cols="12" md="5" sm="12">
            <p class="title-1 form-label">Start Month : </p>
          </v-col>
          <v-col class="pb-0" cols="12" md="7" sm="12">
            <v-menu
              v-model="startCal"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  class="input-field"
                  v-model="activeMasterListData.startMonth"
                  hide-details
                  append-icon="event"
                  dense
                  outlined
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                type="month"
                v-model="activeMasterListData.startMonth"
                @input="startCal = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pb-0" cols="12" md="5" sm="12">
            <p class="title-1 form-label">End Month : </p>
          </v-col>
          <v-col class="pb-0" cols="12" md="7" sm="12">
            <v-menu
              v-model="endCal"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  class="input-field"
                  v-model="activeMasterListData.endMonth"
                  hide-details
                  append-icon="event"
                  dense
                  outlined
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                type="month"
                v-model="activeMasterListData.endMonth"
                @input="endCal = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pb-0" cols="12" md="5" sm="12">
            <p class="title-1 form-label">Remarks : </p>
          </v-col>
          <v-col class="pb-0" cols="12" md="7" sm="12">
            <v-textarea
              v-model="activeMasterListData.remarks"
              placeholder=""
              outlined
              dense
            ></v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="$emit('input')">Close</v-btn>
        <v-btn color="green darken-1" text @click="processUpdate()" :disabled="disableSave">Save</v-btn>
      </v-card-actions>
    </v-card>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="90"
      height.number="90"
    ></loading>
  </v-dialog>
</template>
<script>
import { required } from 'vuelidate/lib/validators'
import moment from 'moment'
import Loading from 'vue-loading-overlay';
import { mapState } from 'vuex'
// import config from '../config';
import MasterListsConfig from './config'
export default {
  name: 'InvoiceSentEditModal',
  components: { Loading },
  data() {
    return {
      activeMasterListData: {
        quoteAmt: '',
        startMonth: '',
        endMonth: '',
        remarks: ''
      },
      quoteAmt: 0,
      startCal: false,
      endCal: false,
      isLoading: false,
      minDate: `${new Date().getFullYear()}-${new Date().getMonth() + 1}`,
      quoteStatuses: MasterListsConfig.quoteStatuses
    };
  },
  props: {
    value: Boolean,
    data: Object,
    editTimelineData: Object,
    editTimelineIdx: Number
  },
  watch: {
    value(value) {
      if (value) {
        if (!this.data.id) return
        this.quoteAmt = this.data.quoteAmt || 0
        // this.activeMasterListData = {}
        this.activeMasterListData.id = this.data.id
        this.activeMasterListData.quoteData = this.data.quoteData || []
        this.activeMasterListData.activity = this.data.activity || []
        this.activeMasterListData.invoiceCreated = this.data.invoiceCreated || 0
        // this.activeMasterListData.invoiceSent = 0
        // this.activeMasterListData.invoicePending = this.data.invoicePending || 0
        // this.activeMasterListData.startMonth = this.data.startMonth || ''
        // this.activeMasterListData.endMonth = this.data.endMonth || ''
        this.activeMasterListData.quoteAmt = 0
        this.activeMasterListData.startMonth = ''
        this.activeMasterListData.endMonth = ''
        this.activeMasterListData.remarks = ''
        if (this.editTimelineData) {
          this.activeMasterListData.startMonth = this.editTimelineData.startMonth || ''
          this.activeMasterListData.endMonth = this.editTimelineData.endMonth || ''
          this.activeMasterListData.quoteAmt = this.editTimelineData.quoteAmt || 0
          this.activeMasterListData.remarks = this.editTimelineData.remarks || ''
        }
      }
    }
  },
  computed: {
    ...mapState({
      masterLists: state => state.campaign.masterLists,
      savedMasterList: state => state.campaign.savedMasterList
    }),
    disableMasterLists() {
      return this.$v.activeMasterListData.$invalid
    },
    availableAmt() {
      let amt = 0
      let enteredAmts = 0
      // billed amount + invoice created
      // if (this.activeMasterListData.activity) {
      //   if (Array.isArray(this.activeMasterListData.activity)) {
      //     this.activeMasterListData.activity.map(activity => {
      //       amt += Number(activity.amount)
      //     })
      //   }
      // }
      if (this.data.invoiceCreated) {
        amt += Number(this.data.invoiceCreated)
      }
      // linked IOs
      if (this.data.linkedIOs) {
        let matchMasterlist = this.masterLists.find(m => this.data.linkedIOs.includes(m.quoteNo.replace('IO-', '')))
        if (matchMasterlist) {
          amt += Number(matchMasterlist.invoiceCreated || 0)
        }
      }
      // entered amounts
      if (this.data.quoteData) {
        if (Array.isArray(this.data.quoteData)) {
          this.data.quoteData.map((quote, idx) => {
            if (quote.quoteAmt && (quote.status === 1 || quote.status === 0) && idx !== this.editTimelineIdx) {
              enteredAmts += Number(quote.quoteAmt)
            }
          })
        }
      }
      // if (this.data.quoteAmt) {
      //   // add current amount
      //   enteredAmts += Number(this.data.quoteAmt)
      // }
      // if (this.editTimelineData) {
      //   // reduce update timeline amt
      //   enteredAmts = enteredAmts - Number(this.editTimelineData.quoteAmt)
      // }
      if (amt > 0) {
        return Number(amt) - Number(enteredAmts)
      }
      return 0
    }
  },
  validations: {
    activeMasterListData: {
      quoteAmt: {
        required
      },
      startMonth: {
        required
      },
      endMonth: {
        required
      }
    }
  },
  methods: {
    async processUpdate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal({
          type: 'error',
          title: `Can't Submit with errors`,
          text: 'Make sure you filled the required information correctly.'
        });
        return;
      }
      // check if entered amt larger
      let totalAvalAmt = this.availableAmt - Number(this.activeMasterListData.quoteAmt)
      if (totalAvalAmt < 0) {
        this.$swal({
          text: 'Available Amount Not Enough.',
          type: 'error'
        });
        return false
      }
      this.$swal({
        title: 'Double Check!',
        text: 'Are you sure you want to save changes?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(async (result) => {
        if (result.value) {
          this.isLoading = true
          let saveData = []
          let quoteData = []
          if (this.activeMasterListData.quoteData) {
            quoteData = Object.assign([], this.activeMasterListData.quoteData)
          }
          let createQuoteData = {
            quoteAmt: Number(this.activeMasterListData.quoteAmt),
            startMonth: this.activeMasterListData.startMonth,
            endMonth: this.activeMasterListData.endMonth,
            remarks: this.activeMasterListData.remarks,
            status: this.quoteStatuses.ACCEPT
          }
          if (this.editTimelineData) {
            quoteData[this.editTimelineIdx] = createQuoteData
          } else {
            quoteData.push(createQuoteData)
          }
          saveData.push(Object.assign({}, {
            id: this.activeMasterListData.id,
            quoteData
          }))
          this.activeMasterListData.quoteData = Object.assign([], quoteData)
          // Submit request to save campaign data
          await this.$store.dispatch('campaign/saveCampaignMasterLists', {
            data: saveData
          })
          this.isLoading = false;
          if (!this.savedMasterList) {
            this.$swal({
              text: 'Error Updating Invoice Sent.',
              type: 'error'
            });
            return
          }
          // Show success message
          this.$swal({
            text: 'Successfully updated.',
            type: 'success'
          });
          this.$emit('created', this.activeMasterListData)
          this.clearForm()
          this.close()
        }
      })
    },
    clearForm() {
      this.activeMasterListData = {
        quoteAmt: '',
        startMonth: '',
        endMonth: '',
        remarks: ''
      }
    },
    close() {
      this.$emit('input');
    },
    formatTime(value) {
      return moment(value).format('DD-MM-YYYY hh:mm:ss');
    }
  }
};
</script>
<style scoped>
  .form-label {
    margin-bottom: 0;
    font-size: 15px;
    font-weight: bold;
    padding-top: 0;
  }
  .custom-danger {
    color: #ff5252 !important;
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// TimelineAmountUpdateModal.vue?0d276396